import axios from "axios";
import { API_BASE_URL, FRONT_END_URL } from "../../../config/config";
import { mailerTokenValueProps } from "../../../utils/types";

export const baseUrl = API_BASE_URL;
export const frontEndUrl = FRONT_END_URL;

export const api = axios.create({
    baseURL : baseUrl,
})

export function getToken(){
    const token = localStorage.getItem('token');
    return token;
}

export const checkAuth = async() =>{
    try{
        const response = await api.get('/check-authentication', {headers : {'Authorization' : 'Bearer '+getToken()}})
        return response.data;
    }catch(e){
        throw new Error('Token is invalid');
    }
}

export const checkMailerToken = (mailerToken : string) : Promise<mailerTokenValueProps> =>{
    return new Promise(async(resolve, reject)=>{
        try{
            const response = await api.get('/check-change-password-token', {headers : {'Authorization' : 'Bearer '+mailerToken}});
            resolve(response.data);
        }catch(e){
           reject(e);
        }
    })
}